export default __webpack_public_path__ + "static/media/banner_siswa.821a00df.svg";